import { render, staticRenderFns } from "./AboutDetail.vue?vue&type=template&id=ad512644&scoped=true"
import script from "./AboutDetail.vue?vue&type=script&lang=js"
export * from "./AboutDetail.vue?vue&type=script&lang=js"
import style0 from "./AboutDetail.vue?vue&type=style&index=0&id=ad512644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad512644",
  null
  
)

export default component.exports